module.exports = __webpack_public_path__ + "static/media/ab3.80955c63.jpeg";